import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Document, Id, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeAttachedDocument(
    request: Boundaries["removeAttachedDocument"]["request"],
  ): void;
}

function useRemoveAttachedDocument(documentId: Id): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveAttachedDocumentRequestPending(documentId),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveAttachedDocumentRequestSuccess(documentId),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveAttachedDocumentRequestFailure(documentId),
    ),
    removeAttachedDocument: core.removeAttachedDocument,
  };
}

export { useRemoveAttachedDocument };
